"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Generates a semi-unique numeric ID by combining current timestamp and a random segment.
 *
 * This improves uniqueness guarantees for local usage like cart items or drafts,
 * without requiring UUIDs or server-generated IDs.
 *
 * @returns A number-based ID composed of current time and random digits.
 */
function generateNumberId() {
  const timestamp = Date.now(); // milliseconds since epoch
  const random = Math.floor(Math.random() * 1000); // 0–999
  return Number("".concat(timestamp).concat(random.toString().padStart(3, '0')));
}
var _default = exports.default = generateNumberId;